export const KEY_GET_ORGANIZATIONS = 'get.organizations.call';
export const KEY_GET_ORGANIZATION_CONFIG = 'get.organization-config.call';
export const KEY_POST_ORGANIZATION_CONFIG = 'post.organization-config.call';
export const KEY_GET_USER_PROFILE = 'get.user-profile.call';
export const KEY_PUT_ACTIVATE_CONTEXT = 'put.activate-context.call';

// TODO: not used for now, but might be useful in the future
export const KEY_PUT_SET_LANGUAGE = 'put.set-language.call';
export const KEY_PUT_SET_ORGANIZATION = 'put.set-organization.call';
export const KEY_GET_USER_WARNINGS = 'get.user-warnings.call';
export const KEY_GET_USER_AUTHORIZE = 'get.user-authorize.call';
export const KEY_POST_CONTACT = 'post.contact.call';
